import { authorizeMe, axiosInstance } from "./commonHeadApiLogic.js";

const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe();
    return await apiFunction(...args);
  } catch (error) {
    console.error("Error in API request:", error);
    throw error;
  }
};

/**
 * Get Tickets List
 * @param {number} page
 * @param {number} limit
 * @param {string} status
 */
export const getTicketsAPI = (page = 1, limit = 10, status = "") => {
  return withAuthorization(async () => {
    return axiosInstance.get(
      `/api/users/tickets?page=${page}&limit=${limit}&status=${status}`
    );
  });
};

/**
 * Update Ticket Status
 * @param {string} ticketId
 * @param {string} status
 */
export const updateTicketStatusAPI = (ticketId, status) => {
  return withAuthorization(async () => {
    return axiosInstance.put(`/api/users/tickets/${ticketId}`, { status });
  });
};

/**
 * Delete Ticket
 * @param {string} ticketId
 */
export const deleteTicketAPI = (ticketId) => {
  return withAuthorization(async () => {
    return axiosInstance.delete(`/api/users/tickets/${ticketId}`);
  });
};
